import { create } from 'zustand'

interface UpgradeModalState {
  isOpen: boolean
  feature: string | null
  open: (feature: string) => void
  close: () => void
}

export const useUpgradeModal = create<UpgradeModalState>((set) => ({
  isOpen: false,
  feature: null,
  open: (feature: string) => set({ isOpen: true, feature }),
  close: () => set({ isOpen: false, feature: null }),
}))
